import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { orderStatus, paymentState, paymentStates, paymentTypes, paymentTypesWithCN } from "@/js/lists.ts";
export default {
  name: "OrderPaymentDetailsDialog",
  props: {
    loggedUserData: Object,
    dialog: Boolean,
    payment: Object,
    order: Object,
    remainingAmount: Number
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      isAdding: false,
      isValidating: false,
      savePaymentToken: null,
      model: {
        id: null,
        state: null,
        paymentDate: new Date().formatForDatePickerDays(),
        type: null,
        typeLabel: null,
        methodId: null,
        microDepositsUrl: null,
        reference: null,
        amount: 0.01,
        scheduleDate: null,
        userId: null,
        orderId: null
      },
      modelPaymentMethod: null,
      modelIsAttachPaymentToAccRecs: true,
      scheduleDateOpened: false,
      paymentDateMenu: false,
      isEditingPayment: false,
      listPaymentMethods: [],
      isSavingPayment: false,
      rules: formRules,
      paymentTypes: paymentTypes,
      paymentTypesWithCN: paymentTypesWithCN,
      paymentState: paymentState,
      paymentStates: paymentStates
    };
  },
  computed: {
    isPaymentEditable: function isPaymentEditable() {
      var _this$payment, _this$payment2;
      return !this.isEditingPayment && (!((_this$payment = this.payment) !== null && _this$payment !== void 0 && _this$payment.state) || ((_this$payment2 = this.payment) === null || _this$payment2 === void 0 ? void 0 : _this$payment2.state) !== paymentState.SUCCEEDED) && this.order.status !== orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    isDisabled: function isDisabled() {
      return !this.model.amount || this.model.state === paymentState.SUCCEEDED && !this.model.paymentDate || !this.model.state;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.payment) {
              _this2.model = _objectSpread(_objectSpread({}, _this2.payment), {}, {
                paymentDate: _this2.payment.paymentDate ? new Date(_this2.payment.paymentDate).formatForDatePickerDays() : new Date().formatForDatePickerDays(),
                scheduleDate: _this2.payment.scheduleDate ? new Date(_this2.payment.scheduleDate).formatForDatePickerDays() : null
              });
            } else {
              _this2.isAdding = true;
              _this2.model.orderId = _this2.order.id_order;
              _this2.model.amount = _this2.remainingAmount;
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    close: function close() {
      this.isValidating = false;
      this.$emit("close");
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$savePaymentTok;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this3.isValidating = true;
              (_this3$savePaymentTok = _this3.savePaymentToken) === null || _this3$savePaymentTok === void 0 || _this3$savePaymentTok.cancel();
              _this3.savePaymentToken = axios.CancelToken.source();
              data = _objectSpread({}, _this3.model);
              if (_this3.order.isPreventInvoice === true && _this3.model.state === paymentState.SUCCEEDED && _this3.remainingAmount <= +_this3.model.amount && _this3.modelIsAttachPaymentToAccRecs === true) {
                data.isAttachPaymentToAccRecs = true;
              }
              if (!_this3.isAdding) {
                _context2.next = 13;
                break;
              }
              _context2.next = 9;
              return request("/v1/payment", "post", data, true, "api", null, _this3.savePaymentToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.isValidating = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the payment.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 9:
              response = _context2.sent;
              if (response) {
                _this3.model.id = response.data.value;
              }
              _context2.next = 15;
              break;
            case 13:
              _context2.next = 15;
              return request("/v1/payment/".concat(_this3.model.id), "put", data, true, "api", null, _this3.savePaymentToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.isValidating = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the payment.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 15:
              _this3.$emit("validate", true, function () {
                _this3.close();
                _this3.$toasted.show("Payment succesfully saved.", {
                  type: "success"
                });
              });
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeAmountCurrency: function changeAmountCurrency() {
      if (this.model.amount < 0.01) {
        this.model.amount = 0.01;
      }
    },
    startEditPaymentMethod: function startEditPaymentMethod() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.listPaymentMethods = [];
              _context3.next = 3;
              return request("/v1/stripe/orders/".concat(_this4.order.id_order, "/payment-methods"), "get", null, true, "api");
            case 3:
              response = _context3.sent;
              if (response) {
                if (response.data.list_bank_accounts) {
                  _this4.listPaymentMethods = [].concat(_toConsumableArray(_this4.listPaymentMethods), _toConsumableArray(response.data.list_bank_accounts.map(function (x) {
                    return {
                      user_id: x.user.id_user,
                      payment_method_id: x.payment_method_id,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "Sepa Direct Debit";
                      }).id,
                      payment_type_label: "Sepa Direct Debit",
                      label: "SEPA".concat(x.default ? " (default)" : "", " - ").concat(x.country, "***").concat(x.bank_name, "******").concat(x.last4)
                    };
                  })));
                }
                if (response.data.list_us_bank_accounts) {
                  _this4.listPaymentMethods = [].concat(_toConsumableArray(_this4.listPaymentMethods), _toConsumableArray(response.data.list_us_bank_accounts.map(function (x) {
                    return {
                      user_id: x.user.id_user,
                      payment_method_id: x.payment_method_id,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "ACH";
                      }).id,
                      payment_type_label: "ACH",
                      label: "ACH".concat(x.default ? " (default)" : "", " - ").concat(x.routing_number, "***").concat(x.bank_name, "******").concat(x.last4)
                    };
                  })));
                }
                if (response.data.list_credit_cards) {
                  _this4.listPaymentMethods = [].concat(_toConsumableArray(_this4.listPaymentMethods), _toConsumableArray(response.data.list_credit_cards.map(function (x) {
                    return {
                      user_id: x.user.id_user,
                      payment_method_id: x.payment_method_id,
                      payment_type: paymentTypesWithCN.find(function (x) {
                        return x.name == "Credit Card";
                      }).id,
                      payment_type_label: "Credit Card",
                      label: "Credit Card".concat(x.default ? " (default)" : "", " - **** **** **** ").concat(x.last4, " - ").concat(x.exp_month, "/").concat(x.exp_year)
                    };
                  })));
                }
              }
              if (_this4.model.methodId) {
                _this4.modelPaymentMethod = _this4.listPaymentMethods.find(function (x) {
                  return x.payment_method_id === _this4.model.methodId;
                });
              } else {
                _this4.modelPaymentMethod = null;
              }
              _this4.isEditingPayment = true;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updatePaymentMethod: function updatePaymentMethod() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.model.methodId = _this5.modelPaymentMethod.payment_method_id;
              _this5.model.type = _this5.modelPaymentMethod.payment_type;
              _this5.model.typeLabel = _this5.modelPaymentMethod.payment_type_label;
              _this5.model.userId = _this5.modelPaymentMethod.user_id;
              _this5.modelPaymentMethod = null;
              _this5.isEditingPayment = false;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removePaymentMethod: function removePaymentMethod() {
      this.model.methodId = null;
      this.model.type = null;
      this.model.typeLabel = null;
      this.model.userId = null;
      this.model.scheduleDate = null;
    },
    cancelPaymentMethod: function cancelPaymentMethod() {
      this.isEditingPayment = false;
    },
    filterDecimal2digitsKey: filterDecimal2digitsKey,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice
  }
};